import { render } from "./ItemNotification.vue?vue&type=template&id=7fc38e36"
import script from "./ItemNotification.vue?vue&type=script&lang=js"
export * from "./ItemNotification.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__